import React from "react"
import Paper from "material-ui/Paper"
import ImageLoader from "../../../misc/ImageLoader"
import strings from "../../../../localization/strings"
import { IBiometricException } from "../../../../models"
interface IProps {
    bioExceptionRecord: IBiometricException
}

const BiometricExceptionConfirmedImages: React.SFC<IProps> = (props: IProps) => {
    return (
        <div
            className="BiometricExceptionConfirmedImages"
            style={{
                margin: "0px auto",
                position: "relative",
                textAlign: "center",
                background: "#e7e7e7",
                paddingLeft: 10,
                paddingRight: 10,
                paddingTop: 10
            }}
        >
            <h2 style={{ textTransform: "uppercase", marginBottom: 0 }}>
                {strings.formatString(strings.CONFIRMED_IMAGES_OF_x, props.bioExceptionRecord ? props.bioExceptionRecord.Record.UserFirstName : "")}
            </h2>
            {props.bioExceptionRecord && props.bioExceptionRecord.CompareImages.map((imageId, i) =>
                <Paper style={{ display: "inline-block", margin: 10 }} zDepth={1} key={imageId}>
                    <ImageLoader url={props.bioExceptionRecord.CompareImageS3Urls[i]} src={"/punches/image/" + imageId} key={imageId} fixedHeight={245} />
                </Paper>
            )}
            <div style={{ clear: "both" }} />
        </div>
    )
}

export default BiometricExceptionConfirmedImages
